import { EmptyState, Skeleton } from '../../components/ui';
import { PageHeader } from '../../layouts/Shells';
import { ListView } from '../listView/ListView';
import { usePersonalProject, useProjectWorkspace } from '../projects/hooks';

/**
 * The personal task space (post-v1.0.0, Todoist-style): a private project
 * created for each person on their first visit, invisible to everyone else,
 * rendered here without the project ceremony. All the task machinery
 * (subtasks, files, comments, Board view, reminders) comes along free
 * because underneath it IS a project.
 */

export function PersonalTasksPage() {
  const personal = usePersonalProject();
  const workspace = useProjectWorkspace(personal.data);

  if (personal.isPending || (personal.isSuccess && workspace.isPending)) {
    return (
      <>
        <PageHeader title="Personal Tasks" topbar />
        <Skeleton lines={4} label="Loading your personal tasks" />
      </>
    );
  }

  if (personal.isError || workspace.isError || !workspace.data) {
    return (
      <>
        <PageHeader title="Personal Tasks" topbar />
        <EmptyState
          title="Your personal space could not be loaded"
          description="Try again in a moment. If this keeps happening, tell an admin."
        />
      </>
    );
  }

  const { project, members, sections, statuses } = workspace.data;

  return (
    <>
      {/* The description stays: it is a promise about who can see this,
          which is not something the title says. */}
      <PageHeader
        title="Personal Tasks"
        topbar
        description="Your own list. Nobody else can see anything here."
      />
      <ListView
        projectId={project.id}
        projectName={project.name}
        sections={sections}
        members={members}
        statuses={statuses}
        canEdit
        canManage
        compact
        // Personal Tasks gets the unified board: permanent status columns, a
        // Completed column that agrees with the checkbox in both directions,
        // and sections as filter tabs rather than a rival column layout.
        boardLayout="unified"
      />
    </>
  );
}
